import _ from "lodash";
import ConfigUtils from "./ConfigUtils";

export const displayValue = (screenerTypes, processVal) => {
  return _.isEmpty(screenerTypes) ? "" : "(" + RequestUtils.getProcessValue(screenerTypes, processVal) + ")";
};

export default class RequestUtils {
  static isListNeeded(deliveryOption, list) {
    let flag = false;
    if (deliveryOption === "Aspera P2P" || deliveryOption === "Aspera Faspex") {
      if (_.isEmpty(list)) {
        flag = true;
      } else if (deliveryOption !== list[0].listName) {
        flag = true;
      } else {
        flag = false;
      }
    }
    return flag;
  }

  static filterProcessorFields = (sourceLocation, fileType, updatedFields) => {
    let overrideProcessor = _.get(_.get(sourceLocation, "override"), "processor");
    let overrideFileType = _.get(overrideProcessor, "*") || _.get(overrideProcessor, fileType);
    if (overrideFileType) {
      // Below condition will take care of the filtering. Similaryl we can add more cases in future for labels etc.
      updatedFields = _.filter(updatedFields, function(field) {
        return !(_.has(overrideFileType, field.ref) && overrideFileType[field.ref].noShow);
      });
    }
    return updatedFields;
  }
  
  static getMetaDataField(metaData, sourceLocation, item) {
    return _.map(metaData, (meta) => {
      let field = _.cloneDeep(_.get(ConfigUtils.getInputComponents(), "inputComponents")[0].dataFields[0][meta]);
      let override = _.get(sourceLocation, "override.metadata");
      if (_.includes(JSON.stringify(override), meta, false)) {
        let findObj = _.find(override, (over) => _.has(over, meta));
        field = Object.assign(field, _.get(findObj, meta));
      }
      if (_.get(field, "referenceDataSource") === "Aspera AoC Accounts" || _.get(field, "referenceDataSource") === "Screeners.com Subdomains") {
        field.referenceDataSource = item[field.referenceDataSource];
      }
      field.ref = meta;
      return Object.assign({}, field);
    });
  }

  static getProcessValue(screenType, process) {
    let testVal = _.find(screenType, (val) => {
      return val.ref === process.screenerType;
    });
    let array = [];
    _.map(_.get(testVal, "metadata"), (val) => {
      let fieldProcess = _.cloneDeep(_.get(ConfigUtils.getInputComponents(), "inputComponents")[0].dataFields[0][val]);
      if (_.get(fieldProcess, "type") === "boolean") {
        let boolVal = _.get(process, val, false) ? "Yes" : "No";
        array.push(fieldProcess.label + " : " + boolVal);
      }
      if (!_.isEmpty(_.get(process, val))) {
        array.push(fieldProcess.label + " : " + _.get(process, val, ""));
      }
    });
    let joiner = _.isEmpty(array) ? " " : " , ";
    return _.isEmpty(process) ? "" : _.get(testVal, "label", "") + joiner + array.join(" , ");
  }

  static getMetaDataField1(metaData, sourceLocation) {
    return _.map(metaData, (meta) => {
      let field = _.cloneDeep(_.get(ConfigUtils.getInputComponents(), "inputComponents")[0].dataFields[0][meta]);
      let override = _.get(sourceLocation, "override.metadata");
      if (_.includes(JSON.stringify(override), meta, false)) {
        let findObj = _.find(override, (over) => _.has(over, meta));
        field = Object.assign(field, _.get(findObj, meta));
      }
      if (meta === "notes") {
        field.type = "textarea";
      }
      field.ref = meta;
      return Object.assign({}, field);
    });
  }

  static getProcessType(process) {
    let group = _.get(process, "fileType");
    let fileType = _.get(process && process.profile, "description");
    return _.find(ConfigUtils.getProcessorTypes(), (type) => {
      return _.get(type, "group") === group && _.get(type, "ref") === fileType;
    });
  }

  static getFileTypeLabel = (fileTypeValue) => {
    let processConfig = _.find(ConfigUtils.getProcessorTypes(), { ref: fileTypeValue });
    let group = _.get(processConfig, "group", "");
    let label = _.get(processConfig, "label", "");
    let name = group === label ? group : group + " " + label;
    name = name.trim();
    return name ? name : fileTypeValue || "";
  }
  static getDisplayProcessValue(fileGroup, _fileType, process) {
    let findLabel = RequestUtils.getProcessType(process);
    let array = [];
    _.map(_.get(findLabel, "metadata"), (val) => {
      let fieldProcess = _.cloneDeep(_.get(ConfigUtils.getInputComponents(), "inputComponents")[0].dataFields[0][val]);
      if (_.get(fieldProcess, "type") === "boolean") {
        let boolVal = _.get(process, val, false) ? "Yes" : "No";
        array.push(fieldProcess.label + " : " + boolVal);
      }
      if (!_.isEmpty(_.get(process, val))) {
        array.push(fieldProcess.label + " : " + _.get(process, val, ""));
      }
    });
    let joiner = _.isEmpty(array) ? " " : " , ";
    let value = fileGroup === _.get(findLabel, "label") ? fileGroup : fileGroup + " " + _.get(findLabel, "label");
    return _.isEmpty(findLabel) ? "" : value + joiner + array.join(" , ");
  }

  static getProcessMeta(jobType, _sourceLocation) {
    let list = _.get(jobType, "processing." + _.get(jobType, "processing.allowedProcesses"));
    return _.map(list, (item) => {
      let field = _.cloneDeep(
        _.find(ConfigUtils.getProcessorTypes(), (type) => {
          return _.get(type, "ref") === item;
        })
      );
      if (item === "notes") {
        field.type = "textarea";
      }
      return Object.assign({}, field);
    });
  }
  static getProcessFieldsFileCreation(_jobType, sourceLocation) {
    const filteredProcess = _.filter(ConfigUtils.getProcessorTypes(), (process) => {
      return _.get(process, "sources", []).includes(_.get(sourceLocation, "type"));
    });
    return _.groupBy(filteredProcess, "group");
  }

  static getProcessFields(processId) {
    return _.find(ConfigUtils.getProcessorTypes(), {ref: processId});
  }

  static getFileGroup(metaField, processType) {
    let selectedFileType = _.filter(metaField, (type) => {
      return _.get(type[0], "group") === processType;
    });
    return _.filter(_.first(selectedFileType), (item) => {
      return _.get(item, "active") === true;
    });
  }
  static getExtension(sourceType, process) {
    let fileGroup = _.get(process, "fileType");
    let fileType = _.get(_.get(process, "profile"), "description");
    return _.find(ConfigUtils.getProcessorTypes(), (proc) => {
      return _.get(proc, "group") === fileGroup && _.get(proc, "ref") === fileType && _.includes(_.get(proc, "sources"), sourceType);
    });
  }
  static getFileField(fileType, sourceType) {
    return _.find(ConfigUtils.getProcessorTypes(), (proc) => {
      return _.get(proc, "ref") === fileType && _.includes(_.get(proc, "sources"), sourceType);
    });
  }
  static getIntendedFilter(intendedFile, sourceType) {
    return _.filter(intendedFile, (file) => {
      return _.find(ConfigUtils.getProcessorTypes(), (process) => {
        return (
          _.get(process, "ref") === _.get(file, "fileType") && _.get(process, "active") === true && _.includes(_.get(process, "sources"), sourceType)
        );
      });
    });
  }

  static getProcessMetaField(screenerType) {
    let field = _.cloneDeep(
      _.find(ConfigUtils.getProcessorTypes(), (type) => {
        return _.get(type, "ref") === screenerType;
      })
    );
    return Object.assign({}, field);
  }

  static getAdditionalDataField(deliveryFields, deliveryOption, _delivery, item) {
    const deliveryOptionsObj = _.find(deliveryFields, (option) => {
      return _.get(option, "label") === deliveryOption || _.get(option, "ref") === deliveryOption;
    });
    return _.map(_.get(deliveryOptionsObj, "metadata"), (meta) => {
      const field = _.cloneDeep(_.get(ConfigUtils.getInputComponents(), "inputComponents")[0].dataFields[0][meta]);

      let override = _.get(deliveryOptionsObj, "override.metadata");

      if (!_.isEmpty(field)) {
        if (_.includes(JSON.stringify(override), meta, false)) {
          let findObj = _.find(override, (over) => _.has(over, meta));
          Object.assign(field, _.get(findObj, meta));
        }
        if (
          _.get(field, "referenceDataSource") === "Aspera P2P Accounts" ||
          _.get(field, "referenceDataSource") === "Aspera AoC Accounts"||
          _.get(field, "referenceDataSource") === "Screeners.com Subdomains"
        ) {
          field.referenceDataSource = item[field.referenceDataSource];
        }
        field.ref = meta;
        return Object.assign({}, _.omit(field, "value"));
      } else {
        return;
      }
    });
  }
  
}
